import GSuiteIcon from '../../assets/gsuite.svg';
import RestApiIcon from '../../assets/rest_api.png';
import {
  FourPointStar,
  CloudShape,
  CloudSmallShape,
  ConnectionPath,
  ElevatedNode,
  DatabaseNode,
  CodeNode,
} from './enterprise-upsell-svgs';

import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import AutoAwesomeOutlined from '@mui/icons-material/AutoAwesomeOutlined';

export default function GpanelApiVideoCardBackground() {
  const theme = useTheme();

  const primaryIconColor = theme.palette.semantic.icon.primary;
  const white = theme.palette.colors.white;

  return (
    <Box
      sx={{
        position: 'absolute',
        top: '-2%',
        left: '80%',
        transform: 'translateX(-50%)',
        width: '565px',
        height: '302px',
        zIndex: 0,
        pointerEvents: 'none',
      }}
    >
      <CloudSmallShape top="45%" left="15%" width={180} height={118} />

      <CloudSmallShape top="14%" left="63%" width={73} height={48} />

      <CloudShape top="7%" left="5%" />

      <FourPointStar size={20} top="18%" left="20%" variant="outlined" />

      <FourPointStar size={20} top="49%" left="5%" variant="filled" />

      <FourPointStar size={40} top="53%" left="8%" variant="filled" />

      <FourPointStar size={36} top="45%" left="70%" variant="outlined" />

      <Box sx={{ position: 'absolute', top: '9%', left: '56%' }}>
        <AutoAwesomeOutlined sx={{ color: primaryIconColor }} />
      </Box>

      <ConnectionPath />
      <Box sx={{ position: 'absolute', top: '43%', left: '15%' }}>
        <ElevatedNode size={52} bgcolor={white} elevation={3}>
          <img
            src={RestApiIcon}
            alt="Google Workspace"
            width={31}
            height={32}
          />
        </ElevatedNode>
      </Box>

      <Box sx={{ position: 'absolute', top: '22%', left: '32%' }}>
        <ElevatedNode size={52} bgcolor={white} elevation={2}>
          <img src={GSuiteIcon} alt="Google Workspace" width={31} height={32} />
        </ElevatedNode>
      </Box>

      <Box sx={{ position: 'absolute', top: '45%', left: '45%' }}>
        <DatabaseNode size={52} />
      </Box>

      <Box sx={{ position: 'absolute', top: '22%', left: '60%' }}>
        <CodeNode size={64} />
      </Box>
    </Box>
  );
}
